// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Lr4t","productName":"Table_productName__2JUGE"};